<template>
  <div>
    <div class="control">
      <div
        style="width: auto; height: 10px; border-bottom: 2px dashed #1e88ff"
      ></div>
      <div class="control2">
        <img src="../images/flow/编组43备份.png" /><span class="fontcss1">身份验证</span>
      </div>
      <div
        style="width: 20%; height: 10px; border-bottom: 2px dashed #1e88ff"
      ></div>
      <div class="control2" style="color: #1e88ff">
        <img src="../images/flow/编组6备份.png" /><span class="fontcss">合同讲解</span>
      </div>
      <div style="width: 20%; height: 10px; border-bottom: 2px dashed #999999"></div>
      <div class="control2">
        <img src="../images/flow/编组6备份6.png" /><span class="fontcss2">电子签名</span>
      </div>
      <div style="width: auto; height: 10px; border-bottom: 2px dashed"></div>
    </div>
    <div>
      <div class="catalogue">
        <div class="catalogue3" @click="returnback">	&lt;返回</div>
        <div class="catalogue1" id="catalogue1" @click="contract">合同</div>
        <div class="catalogue1" id="catalogue2" @click="prospectus">还款计划</div>
      </div>
      <div class="content">
        <span>随e贷产品贷款合同</span>
        <div v-if="judge" class="content1">
          <!-- <img width="250px" height="400px" :src="base64Img"> -->
          <span
            >【特别提示】：借款人在签订本合同之前，请务必仔细阅读本合同全部条款，特别是对黑体部分予以重点关注。如有任何疑问或不明之处，请及时向贷款人及专业人士咨询。本合同一经签订，即视为各方理解并同意本合同全部条款。</span
          >

          <span> 借款人：{{ name }} 贷款人：{{ bank }} </span>

          <span >本合同各方根据有关法律、法规及规章，在平等、自愿的基础上，为明确责任，恪守信用，签订本合同，并承诺共同遵守。</span>
          <span>
            第一条 定义
          </span>
          <span>
              1.1
              个人信用贷款：指由贷款人向符合特定条件的借款人发放的，用于个人合法合规用途的人民币贷款。</span
            >
            <span>
              1.2
              贷款人：网上银行、手机银行等自助渠道显示地区对应的工商银行经办分行或受理借款申请的营业网点所属的工商银行经办行，负责受理借款申请、贷款审批和发放，并与借款人签署本合同，同“贷款经办行”。</span
            >
        </div>
        <div v-else class="content1">
          <span>第五条 贷款申请、审   批与发放</span>
          <span>
            5.1
            借款人可通过网上银行、手机银行等渠道自助或通过营业网点申请办理个人信用贷款。通过网上银行、手机银行等渠道自助申请办理个人信用贷款业务的，借款人申请贷款前应当与贷款人签署《中国工商银行电子银行个人客户服务协议》，承诺遵守《中国工商银行电子银行章程》及相关的交易规定，并按照相关交易规则进行操作。</span
          >
          <span>
            5.2
            借款人须按照营业网点、网上银行、手机银行等提示及要求填写或选择贷款金额、贷款期限、贷款用途、还款方式等，确认或补充本人客户信息。借款人可通过网上银行、手机银行等渠道自助查询申办进度。</span
          >
        </div>
      </div>
      <div class="text1">
          点击下方按钮确认完成合同讲解
           <div class="bnt1" @click="Verification" >完成合同讲解</div> 
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "flow",
  mounted(){
			this.getFile();
    	},
  data() {
    return {
      judge: true,
      bank: "中国工商银行股份有限公司",
      name: "李晓伟",
      base64Img:'',
    };
  },
  methods:{
    getFile(){
          const parames = {
            data: {
              fileCode:"001", 
            },
          };
          this.$_post(this.$API.getFile, parames).then(res => {
              let string= res.data.demoFiles.file1;
              this.base64Img = 'data:image/png;base64,'+string;
          });
      },
      contract(){
         this.judge=true
         this.switchover()
      },
      prospectus (){
          this.judge=false
          this.switchover()
      },
      switchover (){
          let a = document.getElementById("catalogue1")    
          let b = document.getElementById("catalogue2")
          if(this.judge){
              b.style.fontWeight="500"
              a.style.fontWeight="bold"
          }else{
              a.style.fontWeight="500"
              b.style.fontWeight="bold"
          }
      },
      returnback(){
        this.$router.push({path:'/flow1'})
      },
      Verification(){
        // alert("完成合同讲解后到电子签名页面");
        if(true){
           this.$router.push({path:'/esignature'})
        }
      }
  },


};
</script>

<style  scoped>
* {
  margin: 0;
}
.bnt {
  width: 280px;
  height: 5rem;
  font-size: 2rem;
  /* font-weight: bold; */
}
.control {
  width: 280px;
  height: 5rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.control2 {
  font-size: 0.4rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.content {
  width: 300px;
  height: 30rem;
  display: flex;
  /* justify-content: center; */
  overflow-y:auto;
  align-items: center;
  flex-direction: column;
}
.content1 {
  width: 88%;
  display: flex;
  flex-direction: column;
  align-items: baseline;
}
.catalogue{
   width: 300px;
   height: 36px;
   background:#F3F3F3;
   display: flex;
   flex-direction: row;
   color: #09254C;
}
.catalogue1{
    width: 50%;
    /* height: 3rem; */
    background:#F3F3F3;
    display: flex;
    justify-content: center;
    align-items: center;
    line-height: 45px;
    font-size: 1rem;
}   
.catalogue3{
    width: 60px;
    height: 36px;
    background:#F3F3F3;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1rem;
}  
.text1{
   width: 300px;
   display: flex;
   flex-direction: column;
   justify-content: space-around;
   align-items: center;
   /* height: 10rem; */
   color: #333;
}

.bnt1{
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1rem;
    color: #fff;
    background: #3F96FC;
    width: 15rem;
    height: 3rem;
}
.fontcss{
  width: 53px;
  height: 12px;
  font-size: 12px;
  font-family: SourceHanSansCN, SourceHanSansCN-Medium;
  font-weight: 500;
  text-align: center;
  color: #1e88ff;
  line-height: 18px;
}
.fontcss1{
  width: 60px;
  height: 12px;
  font-size: 12px;
  font-family: SourceHanSansCN, SourceHanSansCN-Medium;
  font-weight: 500;
  text-align: center;
  color: #333333;
  line-height: 18px;
}
.fontcss2{
  width: 60px;
  height: 12px;
  font-size: 12px;
  font-family: SourceHanSansCN, SourceHanSansCN-Medium;
  font-weight: 500;
  text-align: center;
  color: #999999;
  line-height: 18px;
}
</style>